//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { extend, debounce } from 'quasar' // extend() replicates jQuery method for cloning
import props from './props'

const deepClone = val => {
  return extend(true, {}, val)
}

// Sets autocomplete input attributes for field types (nothing to do with field type 'autocomplete')
const autocompleteMapping = {
  username: 'username',
  email: 'email',
  password: 'current-password',
  newpassword: 'new-password'
}

// Input field types must be defined here (with optional case and validation rules)
const inputFieldTypes = {
  text: {},
  textarea: {},
  date: {},
  password: {},
  newpassword: {},
  username: {},
  number: {
    rule: val => /^[0-9.-]+$/.test(val) || 'Please use a numeric value'
  },
  phone: {
    rule: val => /^[0-9 ()\\+]+$/.test(val) || 'Invalid format'
  },
  name: {
    case: 'title',
    rule: val => /^[a-zA-Z .-]+$/.test(val) || 'Please use letters only'
  },
  email: {
    case: 'lower',
    rule: val => /\S+@\S+\.\S+/.test(val) || 'Invalid email address'
  },
  url: {
    rule: val => /^(ftp|http|https):\/\/[^ "]+$/.test(val) || 'Invalid URL'
  }
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default {
  name: 'SwoopForm',

  props: props,

  data() {
    return {
      data: this.value,
      page: 1,
      initialData: null,
      model: null,
      visitedFields: [],
      validateAll: false,
      currentFieldId: null,
      showPassword: false,
      showNewPassword: false,
      error: null,
      width: 9999,
      displayCols: 1,
      interval: null,
      optionsCache: {},
      slide: false, // Turns on css transition for sliding the page (when swapping between pages)
      slideOutLeft: false, // Turns on css transformation to slide page out to the left
      slideOutRight: false, // Turns on css transformation to slide page out to the left
      autocompleteOptions: [] // Contains drop-list options for the current autocomplete field
    }
  },

  computed: {
    visibleFields() {
      // Get fields/headings which are visible and on the current page
      return this.model.filter(row => row.isVisible)
    }
  },

  created() {
    this.emitDebounce = debounce(this.emitDebounce, 300)
    this.isDuplicateIds()
    this.setCleanData(this.value)
    this.setData()
    if (this.autofocus) {
      this.focusFirst()
    }
  },

  mounted() {
    this.width = this.$el.clientWidth
    this.setDisplayCols()
    this.interval = setInterval(() => {
      let width = this.$el.clientWidth
      if (this.width !== width) {
        this.width = width
        this.setDisplayCols()
      }
    }, 500)
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    setDisplayCols() {
      let cols = this.cols
      if (cols === 'fit') {
        // If 'fit', set number of columns as total visible fields + any additional field colspans
        let visibleFields = this.model.filter(
          row => row.isVisible && !row.isHeading && !row.isInfoText
        )
        cols = visibleFields.reduce(
          (total, row) => total + (Number(row.field.colspan) || 1),
          0
        )
      }
      if (cols > 12) {
        cols = 12 // Cap at a maximum of 12 cols
      }
      let minFormWidth = 600 // This is the form width below which the fields will start responsively wrapping (unless a form mincolwidth has been specified)
      let mincolwidth = this.mincolwidth || minFormWidth / cols
      while (cols > 1 && this.width / cols - this.colspacing < mincolwidth) {
        cols--
      }
      this.displayCols = cols
    },

    isDuplicateIds() {
      if (
        typeof this.fields !== 'object' ||
        this.fields === null ||
        this.fields.length === undefined
      ) {
        this.error = `An array must be specified for the "fields" property`
        return true
      }
      let duplicates = this.fields.filter(
        (field, idx) =>
          field.id && this.fields.findIndex(f => f.id === field.id) !== idx
      )
      this.error = duplicates.length
        ? `Duplicate field ids are not allowed (${duplicates[0].id})`
        : null
      return !!this.error
    },

    getFieldProps(modelRow, option, optionIndex) {
      let type = modelRow.field.type
      if (type === 'radio' || type === 'checkboxes' || type === 'checkbox') {
        let props = {
          label:
            type === 'checkbox'
              ? modelRow.field.text
              : this.getOptionLabel(option),
          value: modelRow.value,
          dark: this.dark,
          disable: modelRow.isDisabled || modelRow.isReadonly,
          dense: this.dense,
          class: modelRow.field.vertical
            ? 'SwoopForm__optionGroup--vertical'
            : ''
        }
        if (type === 'checkbox') {
          props.ref = modelRow.id
          props['true-value'] = modelRow.field.trueValue
          props['false-value'] = modelRow.field.falseValue
        } else if (type === 'checkboxes') {
          props.ref = !optionIndex ? modelRow.id : null
        } else {
          props.ref = `${modelRow.id}_${optionIndex}`
        }
        if (type !== 'checkbox') {
          props.val = this.getOptionValue(option)
        }
        return this.mergeProps(modelRow, props)
      }

      let props = {
        ref: modelRow.id,
        value: modelRow.value,
        label: modelRow.label,
        bgColor: 'white',
        dark: this.dark,
        error: this.isError(modelRow) || null,
        'error-message': modelRow.error,
        disable: modelRow.isDisabled,
        readonly: modelRow.isReadonly,
        outlined: this.outlined,
        filled: this.filled && !this.outlined,
        rounded: this.rounded,
        square: this.square,
        'stack-label': this.stackLabel || (type === 'date' && !modelRow.value),
        'no-error-icon': true,
        dense: this.dense,
        prefix: this.getFieldProp(modelRow.field, 'prefix'),
        suffix: this.getFieldProp(modelRow.field, 'suffix'),
        hint: this.getFieldProp(modelRow.field, 'hint'),
        hideHint: true,
        hideBottomSpace: true
      }
      if (type === 'list') {
        if (typeof modelRow.field.getOptions === 'function') {
          // If getOptions() is used, options are returned from a callback. Once they have been
          // returned they are stored in a cache for subsequent use.
          if (!this.optionsCache[modelRow.id]) {
            // Create a cache entry...
            this.$set(this.optionsCache, modelRow.id, null)
          }
          props['map-options'] = true
          props.options = this.optionsCache[modelRow.id]
          props.loading = !this.optionsCache[modelRow.id]
          modelRow.field.getOptions(this.data, options => {
            this.$set(this.optionsCache, modelRow.id, options) // Triggered when done(options) is called from the field definition
          })
        } else {
          props.options = this.getFieldProp(modelRow.field, 'options') || []
          if (typeof props.options[0] === 'object') {
            // If options contain label/value objects, set option that tells Quasar to lookup current value
            props['map-options'] = true
          }
        }
      } else if (
        type === 'autocomplete' &&
        typeof modelRow.field.getOptions === 'function'
      ) {
        props['map-options'] = true
        props.options = this.autocompleteOptions
        props.useInput = true
        props.hideSelected = true
        props.fillInput = true
        props.inputDebounce = 300
        props.class = 'autocomplete'
      } else if (type === 'password') {
        props.type = this.showPassword ? null : 'password'
      } else if (type === 'newpassword') {
        props.type = this.showNewPassword ? null : 'password'
      } else {
        props.type = type
      }
      if (type === 'textarea') {
        props.autogrow = true
        props.type = 'text'
      }
      this.setAutocompleteInputAttr(props, type)
      return this.mergeProps(modelRow, props)
    },

    setAutocompleteInputAttr(props, type) {
      // Sets any necessary autocomplete input attribute based on field type (nothing to do with 'autocomplete' field types)
      let autocomplete = autocompleteMapping[type]
      if (autocomplete) {
        props.autocomplete = autocomplete
      }
    },

    mergeProps(modelRow, props) {
      // Used to merge "pass through" field props (being sent to Quasar) with our
      // own SwoopForm props.
      if (modelRow.field.quasarProps) {
        return extend(true, props, modelRow.field.quasarProps)
      }
      return props
    },

    getColSpacing(modelRow) {
      if (modelRow.field.colspacing !== undefined) {
        return this.getFieldProp(modelRow.field, 'colspacing', this.colspacing)
      }
      return this.colspacing
    },

    getRowSpacing(modelRow) {
      if (modelRow.isLineBreak || modelRow.isHeading || modelRow.isInfoText) {
        return 0
      }
      if (modelRow.field.rowspacing !== undefined) {
        return this.getFieldProp(modelRow.field, 'rowspacing', this.rowspacing)
      }
      return this.rowspacing
    },

    getFieldStyle(modelRow) {
      let styles = ''
      let colSpacing = this.getColSpacing(modelRow)
      let rowSpacing = this.getRowSpacing(modelRow)
      let fieldWidth = this.getFieldWidth(modelRow)
      if (colSpacing) {
        styles += `padding-right:${colSpacing}px;`
      }
      if (rowSpacing) {
        styles += `padding-bottom:${rowSpacing}px;`
      }
      if (fieldWidth) {
        styles += `${fieldWidth}`
      }
      return styles
    },

    getFieldWidth(modelRow) {
      // If field colspan is set as a proportion (e.g. "1/5") then return a percentage width
      try {
        let parts = modelRow.field.colspan.split('/')
        if (parts.length === 2) {
          return `width:${(parts[0] / parts[1]) * 100}%;`
        }
      } catch (e) {
        return null
      }
    },

    getValue(field, isInitial) {
      try {
        if (typeof field.value === 'function') {
          // If a value() function exists we run it to get a calculated value
          let val = field.value(this.data)
          if (field.id) {
            // If an id exists with a value function we update that field id with the result of the value function
            this.setValue(field.id, val)
          }
          return val
        }

        // Only eval if id is an object reference...
        if (field.id.indexOf('.') > 0 || field.id.indexOf('[') > 0) {
          return eval(`this.${isInitial ? 'initialData' : 'data'}.${field.id}`)
        }
        // Otherwise return value normally (which is faster performance)
        return isInitial ? this.initialData[field.id] : this.data[field.id]
      } catch (e) {
        return undefined
      }
    },

    getOptionValue(option) {
      return option.value === undefined ? option : option.value
    },

    getOptionLabel(option) {
      return option.label === undefined ? option : option.label
    },

    setValue(id, value) {
      try {
        if (id.indexOf('.') > 0 || id.indexOf('[') > 0) {
          eval(`this.data.${id} = value`)
        } else {
          this.data[id] = value
        }
      } catch (e) {
        this.log(`SWOOP FORM ERROR - Cannot set field "${id}"`)
      }
    },

    getFieldProp(field, propName, defaultValue) {
      // defaultValue is used when propName is undefined
      let prop = field[propName]
      if (typeof prop === 'function') {
        try {
          prop = prop(this.data)
        } catch (e) {
          this.log(
            `SWOOP FORM ERROR - Cannot get propery "${field.id} > ${propName}"`
          )
        }
      }
      if (prop === undefined) {
        return defaultValue
      }
      return prop
    },

    getFormClass() {
      let classes = [
        'SwoopForm',
        'SwoopForm--override',
        `SwoopForm--${this.dense ? 'dense' : 'undense'}`
      ]
      if (this.dark) {
        classes.push('SwoopForm--dark')
      }
      if (this.filled) {
        classes.push('SwoopForm--filled')
      }
      if (this.border) {
        classes.push('shadowborder')
      }
      if (this.rowlines) {
        classes.push('rowlines')
      }
      if (this.labelcaps) {
        classes.push('labelcaps')
      }
      if (this.outlined) {
        classes.push('SwoopForm--outlined')
      }
      if (this.displayCols > 1) {
        classes.push('colspan' + this.displayCols)
      }
      if (this.slide) {
        classes.push('slide')
      }
      if (this.slideOutLeft) {
        classes.push('slideOutLeft')
      }
      if (this.slideOutRight) {
        classes.push('slideOutRight')
      }
      return classes.join(' ')
    },

    getFieldClass(modelRow, rowIdx) {
      if (modelRow.isLineBreak) {
        return 'SwoopForm__lineBreak'
      }
      let classes = 'SwoopForm__field'
      if (this.asterisk && modelRow.isMissing) {
        classes += ' SwoopForm--showAsterisk'
      }
      if (modelRow.field.type === 'slot') {
        classes += ' SwoopForm__slotParent'
      }
      if (modelRow.field.size === 'large') {
        classes += ' large'
      }
      if (rowIdx === 0) {
        classes += ' first'
      }
      if (this.displayCols > 1) {
        let cols = Number(modelRow.field.colspan)
        if (modelRow.isHeading || modelRow.isInfoText || cols >= 12) {
          classes += ' colspan12'
        } else if (cols > 1) {
          classes += ` colspan${cols}`
        } else {
          classes += ' colspan1'
        }
        return classes
      }
      return classes + ' colspan12'
    },

    getOptionGroupClass(modelRow) {
      let classes = 'SwoopForm__optionGroup'
      if (this.dark) {
        classes += ' q-field--dark'
      }
      if (modelRow.field.type === 'checkbox') {
        classes += ' singleCheckbox'
      }
      return classes
    },

    getOptionGroupLegendClass(modelRow) {
      let classes = 'SwoopForm__label q-field__label'
      if (this.isError(modelRow)) {
        classes += ' text-negative'
      }
      return classes
    },

    setData() {
      // Sets internal form data from value prop
      this.data = this.value
      this.buildModel()
    },

    setCleanData(data) {
      this.initialData = deepClone(data) // Clone data for dirty checking
    },

    setCase(modelRow, val) {
      let isNewText = !modelRow.value || val.indexOf(modelRow.value) === 0
      let fieldType = inputFieldTypes[modelRow.field.type] || {}
      let fieldCase = modelRow.field.case || fieldType.case
      if (!fieldCase || !isNewText) {
        return val
      } else if (fieldCase === 'sentence') {
        return val.charAt(0).toUpperCase() + val.slice(1)
      } else if (fieldCase === 'title') {
        return val.replace(/\b[a-z]/g, x => x.toUpperCase())
      } else if (fieldCase === 'lower') {
        return val.toLowerCase()
      } else if (fieldCase === 'upper') {
        return val.toUpperCase()
      }
    },

    isInputField(modelRow) {
      return !modelRow.field.type || !!inputFieldTypes[modelRow.field.type]
    },

    isEmpty(val) {
      return (
        val === undefined ||
        val === null ||
        val === '' ||
        (typeof val === 'object' &&
          Object.keys(val).length === 0 &&
          !val.length)
      )
    },

    isEqual(val1, val2) {
      if (typeof val1 === 'object' || typeof val2 === 'object') {
        return JSON.stringify(val1) === JSON.stringify(val2)
      }
      return val1 === val2
    },

    isError(modelRow) {
      const isModifiedValue = () => {
        /*
          If the current field being edited has an error, we only want to show the error if
          a pre-existing value has been edited. If there was no pre-existing value, the error
          should not show until leaving the field.
        */
        return (
          this.currentFieldId === modelRow.id &&
          !this.isEmpty(modelRow.initialValue)
        )
      }
      return (
        modelRow.isError &&
        (this.validateAll ||
          this.visitedFields.indexOf(modelRow.id) >= 0 ||
          isModifiedValue())
      )
    },

    onInput(modelRow, val) {
      let isInputField = this.isInputField(modelRow)
      if (isInputField) {
        val = this.setCase(modelRow, val.trimStart())
      }

      if (
        (modelRow.field.type === 'list' ||
          modelRow.field.type === 'autocomplete') &&
        val &&
        typeof val === 'object'
      ) {
        // Quasar droplists return label/value object if using labels & values.
        // We need to extract the actual value...
        val = val.value
      }

      this.setValue(modelRow.id, val)
      if (!isInputField) {
        this.addToVisitedFields(modelRow) // Allows errors to highlight as soon as droplist value is changed (for input field this is done on blur)
      }
      this.buildModel(true)
    },

    onFilter(modelRow, val, done) {
      // @filter is called by autocompletes when keystrokes are made (debounced). This method must return an array of applicable list options for the entered value.
      modelRow.field.getOptions(val, options => {
        done(() => (this.autocompleteOptions = options))
      })
    },

    onFocus(modelRow) {
      this.currentFieldId = modelRow.id
    },

    onBlur(modelRow, e) {
      if (
        modelRow.field.type === 'checkboxes' ||
        modelRow.field.type === 'radio'
      ) {
        let isLeavingField =
          !e.relatedTarget ||
          e.target.parentElement.outerHTML !==
            e.relatedTarget.parentElement.outerHTML
        if (!isLeavingField) {
          return
        }
      }
      this.addToVisitedFields(modelRow)
      this.$emit('blur', modelRow.id)
    },

    addToVisitedFields(modelRow) {
      if (this.visitedFields.indexOf(modelRow.id) === -1) {
        this.visitedFields.push(modelRow.id)
      }
    },

    clearValidation(emitUpdate) {
      this.validateAll = false
      this.visitedFields = []
      this.buildModel(emitUpdate)
    },

    focus(modelRow) {
      if (modelRow && !modelRow.isHidden) {
        let fieldRef = this.$refs[modelRow.id]
        if (modelRow.field.type === 'radio') {
          let selectedOptionIndex = modelRow.field.options.findIndex(opt =>
            opt.value !== undefined
              ? opt.value === modelRow.value
              : opt === modelRow.value
          )
          fieldRef = this.$refs[
            `${modelRow.id}_${
              selectedOptionIndex === -1 ? 0 : selectedOptionIndex
            }`
          ]
        }

        if (
          modelRow.field.page &&
          this.page &&
          modelRow.field.page !== this.page
        ) {
          // Change page if necessary to find field...
          this.page = modelRow.field.page
          this.buildModel()
          setTimeout(() => focusField(fieldRef), 0)
        } else {
          focusField(fieldRef)
        }
      }

      function focusField(fieldRef) {
        try {
          if (fieldRef.focus) {
            fieldRef.focus()
          } else if (
            modelRow.field.type === 'checkboxes' ||
            modelRow.field.type === 'radio'
          ) {
            fieldRef[0].$el.focus()
          } else if (modelRow.field.type === 'checkbox') {
            fieldRef.$el.focus()
          }
        } catch (e) {
          // Unable to focus - probably because parent is hidden
        }
      }
    },

    focusFirst() {
      let modelRow = this.model.find(row => this.isInteractiveField(row))
      if (modelRow) {
        setTimeout(() => this.focus(modelRow), 0) // Timeout allows field rendering to complete before setting focus
      }
    },

    focusFirstVisible() {
      let modelRow = this.model.find(
        row =>
          this.isInteractiveField(row) &&
          (!this.page || row.field.page === this.page)
      )
      if (modelRow) {
        setTimeout(() => this.focus(modelRow), 0) // Timeout allows field rendering to complete before setting focus
      }
    },

    isInteractiveField(modelRow) {
      return (
        !modelRow.isHeading &&
        !modelRow.isInfoText &&
        !modelRow.isLineBreak &&
        !modelRow.isSlot &&
        !modelRow.isDisabled &&
        !modelRow.isReadonly &&
        !modelRow.isHidden
      )
    },

    validate(modelRow) {
      modelRow.error = null
      modelRow.isMissing = false
      modelRow.isInvalid = false
      if (!modelRow.isHidden && !modelRow.isDisabled && !modelRow.isReadonly) {
        modelRow.isMissing = modelRow.isRequired && this.isEmpty(modelRow.value)
        if (modelRow.isMissing) {
          modelRow.error = 'Answer required'
        } else {
          modelRow.error = this.testRules(modelRow)
          modelRow.isInvalid = !!modelRow.error
        }
      }
      modelRow.isError = !!modelRow.error
    },

    testRules(modelRow) {
      try {
        let message
        if (!this.isEmpty(modelRow.value)) {
          message = this.validateFieldType(modelRow)
          if (message) {
            return message
          }
        }
        let rules = modelRow.field.rules || []
        let idx = 0
        while (idx < rules.length) {
          message = rules[idx](modelRow.value, this.data)
          if (message !== true) {
            return message
          }
          idx++
        }
        return null
      } catch (e) {
        this.log(`SWOOP FORM ERROR - "${modelRow.id}" rules are invalid`)
      }
      return null
    },

    validateFieldType(modelRow) {
      let message = null
      let fieldType = inputFieldTypes[modelRow.field.type]
      if (fieldType && fieldType.rule) {
        message = fieldType.rule(modelRow.value)
      }
      return message === true ? null : message
    },

    buildModel(emitUpdate) {
      /* 
        SwoopForm is rendered purely from the model object. The model is constructed
        each time a field value changes. It contains all field values for the form,
        but also contains other evaluated flags and values necessary for building 
        the form UI. 
      */
      let model = []
      let modelRow
      let currentField
      this.fields.forEach(f => {
        let field = { ...f } // Clone field object to avoid any mutation
        modelRow = {
          id: field.id || null,
          field: field,
          label: this.getFieldProp(field, 'label'),
          isHidden: !!this.getFieldProp(field, 'hidden'),
          isHeading: !!field.heading,
          isInfoText: !!field.infotext,
          isSlot: field.type === 'slot'
        }
        modelRow.isVisible =
          !modelRow.isHidden && (!field.page || field.page === this.page)
        if (!modelRow.isHeading && !modelRow.isInfoText) {
          let val = this.getValue(field)
          modelRow.value = val
          modelRow.initialValue = this.getValue(field, true)
          modelRow.isDisabled =
            !!this.getFieldProp(field, 'disabled') ||
            typeof field.value === 'function'
          modelRow.isReadonly = !!this.getFieldProp(field, 'readonly')
          modelRow.isRequired = !!this.getFieldProp(field, 'required')
          modelRow.isDirty = !this.isEqual(val, modelRow.initialValue)
          this.validate(modelRow)
        }
        if (field.newline) {
          model.push({
            isLineBreak: true,
            isVisible: modelRow.isVisible,
            field: {}
          })
        }
        model.push(modelRow)
        if (modelRow.id === this.currentFieldId) {
          currentField = modelRow
        }
      })
      this.model = model
      if (emitUpdate) {
        this.$emit('input', this.data, currentField)
        this.emitDebounce(this.data, currentField)
      }
    },

    emitDebounce(data, modelRow) {
      this.$emit('debounce', data, modelRow)
    },

    log(message) {
      console.log(message) // eslint-disable-line no-console
    }
  },

  watch: {
    value() {
      this.setData()
    },
    cols() {
      this.setDisplayCols()
    },
    colspacing() {
      this.setDisplayCols()
    },
    mincolwidth() {
      this.setDisplayCols()
    }
  },

  beforeCreate() {
    // RETURNS API
    this.$emit('api', {
      load: (data, focusFirstField) => {
        /*
          If you want to display a different record while keeping the form visible, you should
          use this load() method. It will take the new record data and set it as the new "clean"
          dataset (resetting any validation errors). If no data is passed in, the form will reload 
          the current v-model data.
        */
        this.data = data
        this.setCleanData(this.data)
        if (this.page > 1) {
          this.page = 1
        }
        this.clearValidation(true)
        if (focusFirstField || (this.autofocus && focusFirstField !== false)) {
          this.focusFirst()
        }
      },
      clearValidation: () => {
        this.clearValidation(true)
      },
      refresh: () => {
        this.setData()
      },
      getPage: () => {
        return this.page
      },
      setPage: async page => {
        if (page !== this.page) {
          /*
            When changing pages we do a slide animation to give the impression of moving from one
            page to the next. However we just have a single form which is displaying fields for the 
            next page, so we slide it out of view, refresh it to show the new fields, then turn off
            transitions and transformations to make it appear again.
          */
          this.slide = true
          if (page < this.page) {
            this.slideOutRight = true
          } else {
            this.slideOutLeft = true
          }
          this.page = page

          await timeout(210)
          this.slide = false
          this.slideOutRight = false
          this.slideOutLeft = false

          this.buildModel()
          this.focusFirstVisible()
        }
      },
      isDirty: () => {
        return !!this.model.find(row => row.isDirty)
      },
      getDirty: () => {
        return this.model.filter(row => row.isDirty)
      },
      getMissing: () => {
        return this.model.filter(row => row.isMissing)
      },
      getInvalid: () => {
        return this.model.filter(row => row.isInvalid)
      },
      isError: () => {
        return !!this.model.find(row => row.error)
      },
      isErrorOnPage: () => {
        return !!this.model.find(
          row => row.error && row.field.page === this.page
        )
      },
      focus: id => {
        setTimeout(() => {
          let modelRow = this.model.find(row => row.id === id)
          this.focus(modelRow)
        }, 0)
      },
      focusFirst: () => {
        this.focusFirst()
      },
      focusFirstVisible: () => {
        this.focusFirstVisible()
      },
      focusError: allPages => {
        let modelRow = allPages
          ? this.model.find(r => r.error)
          : this.model.find(r => r.error && r.field.page === this.page)
        if (modelRow) {
          if (!modelRow.isVisited) {
            this.visitedFields.push(modelRow.id)
          }
          this.focus(modelRow) // Focuses first error
        }
        return !!modelRow // Returns true if focus was set or false if no error fields
      },
      validate: () => {
        this.validateAll = true
      },
      getModel: () => {
        return this.model
      },
      reset: () => {
        this.currentFieldId = null
        this.validateAll = false
        this.visitedFields = []
        this.data = deepClone(this.initialData)
        this.buildModel(true)
      }
    })
  }
}
